<!--
/**
* @name: Add.vue
* @description: 交易管理-添加下单开关设置页面
* @author: 杨波
* @create: 2020/08/17 14:06:58
* @update: 2020/08/17 14:06:58
*/
-->

<template>
  <y-view :loading="isLoading">
    <div class="form-box">
      <template v-if="!isView">
        <y-form title="禁止下单设置:" gutter="25px 30px" titleAlign="right" titleWidth="100px" contentWidth="300px">
          <y-form-item title="名称:" required>
            <k-input placeholder="请输入名称" block clearable v-model="editPara.name"></k-input>
          </y-form-item>
          <y-form-item title="销售渠道:" block required>
            <k-select2
              v-model="editPara.saleChannelList"
              :class="css.inputW"
              :data="channelList"
              text-field="name"
              search-field="name"
              key-field="code"
              style="width: 300px;"
              layer-width="auto"
              layerMinWidthEqual
              :nearby="true"
              placeholder="请选择销售渠道"
            ></k-select2>
          </y-form-item>
          <y-form-item title="终端来源:" required>
            <div>
              <k-checkbox type="arr" :data-arr.sync="editPara.clientTypeList" value="ios" text="IOS"></k-checkbox>
              <k-checkbox type="arr" :data-arr.sync="editPara.clientTypeList" value="android" text="Android"></k-checkbox>
              <k-checkbox type="arr" :data-arr.sync="editPara.clientTypeList" value="applet" text="C端小程序"></k-checkbox>
            </div>
          </y-form-item>
          <y-form-item title="地区限制:" required>
            <div>
              <k-radio v-model="isAreaLimit" value="0">不限制</k-radio>
              <k-radio v-model="isAreaLimit" value="1">限制</k-radio>
              <k-button v-if="isAreaLimit == '1'" type="primary" size="mini" class="ml-1" @click="openAreaPopupShow">选择</k-button>
            </div>
          </y-form-item>
          <y-form-item title="已选择地区:" v-if="isAreaLimit == '1'">
            <div :class="css.box">
              <span v-for="(item, index) in selectedArea" :key="index">{{ item.areaName }} <i v-if="index + 1 != selectedArea.length">，</i></span>
            </div>
          </y-form-item>
          <y-form-item title="仓库限制:" required>
            <div>
              <k-radio v-model="iswareHouseLimit" value="0">不限制</k-radio>
              <k-radio v-model="iswareHouseLimit" value="1">限制</k-radio>
              <k-button v-if="iswareHouseLimit == '1'" type="primary" size="mini" class="ml-1" @click="openWarehousePopupShow">选择</k-button>
            </div>
          </y-form-item>
          <y-form-item title="已选择仓库:" v-if="iswareHouseLimit == '1'">
            <div :class="css.box">
              <span v-for="(item, index) in selectedWareSeatRows" :key="index">{{ item.name }} <i v-if="index + 1 != selectedWareSeatRows.length">，</i></span>
            </div>
          </y-form-item>
          <y-form-item title="生效时间:" required>
            <DatePicker :editable="false" type="datetimerange" @on-change="changeDate" :value="effectDate" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择生效时间" style="width: 280px;"></DatePicker>
          </y-form-item>
          <y-form-item title="前台下单提示:" required>
            <k-input tag="textarea" placeholder="请输入前台下单提示" block v-model="editPara.remark"></k-input>
          </y-form-item>
        </y-form>
        <div class="spliter"></div>
        <y-form id="limit" gutter="25px 30px" titleAlign="left" titleWidth="50px" contentWidth="300px">
          <div :class="css.whiteBox">
            <h3>白名单添加<k-icon class="k-icon-tip ml-1" color="#000"></k-icon></h3>
            <div :class="css.tip">
              添加白名单后，白名单对应的手机号仍可正常下单，不受下单规则限制
            </div>
          </div>
          <y-form-item align="top">
            <y-button icon="k-icon-add" :class="css.btn" @click="addWhiteList">添加白名单</y-button>
          </y-form-item>
        </y-form>
        <div :class="css.box" v-if="editPara.whitelist && editPara.whitelist.length > 0">
          <div :class="css.whiteList" v-for="(item, index) in editPara.whitelist" :key="index">
            <span>{{ item.value }}</span>
            <k-icon class="k-icon-close-circle" color="#f00" @click="onDelete(index)"></k-icon>
          </div>
        </div>
      </template>
      <template v-else>
        <y-form title="禁止下单设置:" titleAlign="right" titleWidth="100px" contentWidth="300px">
          <y-form-item title="名称:" required>
            <span>{{ editPara.name }}</span>
          </y-form-item>
          <y-form-item title="销售渠道:" block required>
            <span>{{ editPara.saleChannelList | filterCompany(this.channelList) }}</span>
          </y-form-item>
          <y-form-item title="终端来源:" required>
            <span>{{ editPara.clientTypeList | filterCompany(this.clientTypeList) }}</span>
          </y-form-item>
          <y-form-item title="地区限制:" required>
            <span>{{ isAreaLimit == "1" ? "限制" : "不限制" }}</span>
          </y-form-item>
          <y-form-item title="已选择地区:" v-if="isAreaLimit == '1'">
            <div :class="css.box">
              <span v-for="(item, index) in selectedArea" :key="index">{{ item.areaName }} <i v-if="index + 1 != selectedArea.length">，</i></span>
            </div>
          </y-form-item>
          <y-form-item title="仓库限制:" required>
            <span>{{ iswareHouseLimit == "1" ? "限制" : "不限制" }}</span>
          </y-form-item>
          <y-form-item title="已选择仓库:" v-if="iswareHouseLimit == '1'">
            <div :class="css.box">
              <span v-for="(item, index) in selectedWareSeatRows" :key="index">{{ item.name }} <i v-if="index + 1 != selectedWareSeatRows.length">，</i></span>
            </div>
          </y-form-item>
          <y-form-item title="生效时间:" required>
            <span>{{ editPara.startTime }} - {{ editPara.endTime }}</span>
          </y-form-item>
          <y-form-item title="前台下单提示:" required>
            <span>{{ editPara.remark }}</span>
          </y-form-item>
        </y-form>
        <div class="spliter"></div>
        <y-form id="limit" gutter="25px 30px" titleAlign="left" titleWidth="50px" contentWidth="300px">
          <div :class="css.whiteBox">
            <h3>白名单添加<k-icon class="k-icon-tip ml-1" color="#000"></k-icon></h3>
            <div :class="css.tip">
              添加白名单后，白名单对应的手机号仍可正常下单，不受下单规则限制
            </div>
          </div>
        </y-form>
        <div :class="css.box" v-if="editPara.whitelist && editPara.whitelist.length > 0">
          <div :class="css.whiteList" v-for="(item, index) in editPara.whitelist" :key="index">
            <insensitive :val="item.value" type="phone"></insensitive>
          </div>
        </div>
      </template>
    </div>
    <k-popup bind="v-if" okText="确认" title="新增白名单" :show.sync="isShowPopup" @after-ok="onSubmit">
      <div style="width: 650px;">
        <y-form titleAlign="left" titleWidth="100px" contentWidth="400px">
          <y-form-item title="手机号:">
            <k-input tag="textarea" placeholder="请用英文逗号隔开..." block v-model="whitelist"></k-input>
          </y-form-item>
        </y-form>
      </div>
    </k-popup>
    <k-popup bind="v-if" layout="header,body,close,mask" title="地区选择" :show.sync="isShowAreaPopup">
      <y-view :loading="isLoading" style="width: 650px; min-height: 400px;">
        <k-tree
          :data.sync="provinceList"
          searchField="areaName"
          :selectedData.sync="selectedAreaRows"
          :selectedKeys.sync="editPara.areaList"
          class="mt-1"
          selectedRule="every"
          childField="children"
          keyField="areaCode"
          textField="areaName"
          hasCheckbox
        ></k-tree>
      </y-view>
    </k-popup>
    <k-popup bind="v-if" layout="header,body,close,mask" title="仓库选择" :show.sync="isShowWareHousePopup">
      <div style="width: 650px;">
        <k-table
          :data="wareSeatList"
          hasCheckbox
          checkboxKey="code"
          :selectedRows.sync="selectedWareSeatRows"
          :selectedKeys.sync="editPara.wcodeList"
          :rightFixedNumber="1"
          :columns="initWareSeatColumns()"
        ></k-table>
      </div>
    </k-popup>
    <div slot="bottom" v-if="!isView">
      <k-button @click="onReset" v-if="isEdit">重置</k-button>
      <k-button @click="onCancel(true, false)" v-else>取消</k-button>
      <k-button type="primary" @click="onSave" :disabled="saveButtonStatus">保存</k-button>
    </div>
  </y-view>
</template>

<script>
import {
  NESTLE_TRADE_BACK_SERVER_BASE_DATA_AREA_PROVINCE,
  NESTLE_TRADE_BACK_SERVER_ORDER_BAN_RULE_UPDATE,
  NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_WARE_LIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
  NESTLE_TRADE_BACK_SERVER_ORDER_BAN_RULE_SAVE,
  NESTLE_TRADE_BACK_SERVER_BASE_DATA_AREA_LIST,
  NESTLE_TRADE_BACK_SERVER_ORDER_BAN_RULE_DETAIL,
} from "@/assets/modules/apiList";

const initEditPara = () => ({
  name: "",
  saleChannelList: [],
  clientTypeList: [],
  areaList: [],
  wcodeList: [],
  whitelist: [],
  remark: "",
  startTime: "",
  endTime: "",
});
export default {
  data() {
    return {
      isLoading: false,
      isAreaLimit: "",
      iswareHouseLimit: "",
      isShowPopup: false,
      isShowAreaPopup: false,
      isShowWareHousePopup: false,
      whitelist: "",
      provinceList: [],
      wareSeatList: [],
      effectDate: "",
      channelList: [],
      editPara: initEditPara(),
      isSaving: false,
      isView: false,
      isEdit: false,
      originData: {},
      selectedAreaRows: [],
      selectedWareSeatRows: [],
      selectedArea: [],
      selectedAreaCode: [],
      clientTypeList: [
        {
          code: "ios",
          name: "IOS",
        },
        {
          code: "android",
          name: "Android",
        },
        {
          code: "applet",
          name: "C端小程序",
        },
      ],
    };
  },
  watch: {
    isAreaLimit(newValue) {
      if (newValue == "0") {
        this.editPara.areaList = [];
        this.selectedAreaCode = [];
        this.selectedArea = [];
        this.selectedAreaRows = [];
      }
    },
    iswareHouseLimit(newValue) {
      if (newValue == "0") {
        this.editPara.wcodeList = [];
        this.selectedWareSeatRows = [];
      }
    },
    selectedAreaRows(newValue) {
      let arr = newValue.slice();
      newValue.map((a) => {
        if (a.level == 2) {
          // 数据里有省时优先过滤区数据
          const city1 = arr.filter((y) => y.parentCode == a.areaCode);
          city1.map((y) => {
            arr = arr.filter((s) => s.parentCode != y.areaCode);
          });
          // 过滤市
          arr = arr.filter((y) => y.parentCode != a.areaCode);
        }
        if (a.level == 3) {
          // 数据里有市时过滤区数据
          arr = arr.filter((y) => y.parentCode != a.areaCode);
        }
      });
      this.selectedArea = arr;
    },
  },
  filters: {
    filterCompany(code, arr) {
      let tmp = [];
      arr.forEach((a) => {
        code.forEach((b) => {
          if (b == a.code) {
            tmp.push(a.name);
          }
        });
      });
      return tmp.join(",");
    },
  },
  computed: {
    saveButtonStatus() {
      let status = false;
      let para = JSON.parse(JSON.stringify(this.editPara));
      para.startTime = this.effectDate && this.effectDate.length > 0 ? this.effectDate[0] : "";
      para.endTime = this.effectDate && this.effectDate.length > 0 ? this.effectDate[1] : "";
      if (!this.isView) {
        let name = para.name.toString().replace(/\s*/g, "");
        if (
          name.length < 2 ||
          para.saleChannelList.length === 0 ||
          para.clientTypeList.length === 0 ||
          !this.isAreaLimit ||
          !this.iswareHouseLimit ||
          (this.isAreaLimit == "1" && para.areaList.length === 0) ||
          (this.iswareHouseLimit == "1" && para.wcodeList.length === 0) ||
          !para.remark ||
          !para.startTime ||
          !para.endTime
        ) {
          status = true;
        }
      }
      return status;
    },
  },
  methods: {
    // selectData(list, data) {
    //   let item = '';
    //   list.map((v) => {
    //     if (v.areaCode == data) {
    //       item = v;
    //     }
    //   });
    //   return item;
    // },
    initPrivinceColumns() {
      return [
        {
          name: "地区名称",
          field: "areaName",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "地区编码",
          field: "areaCode",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
      ];
    },
    initWareSeatColumns() {
      return [
        {
          name: "仓库名称",
          field: "seatName",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "仓库编码",
          field: "seatCode",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
      ];
    },
    addWhiteList() {
      this.isShowPopup = true;
    },
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "switchManagement",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },
    onReset() {
      this.editPara = JSON.parse(JSON.stringify(this.originData));
      this.editPara.areaList = [];
    },
    onSave() {
      const { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      para.startTime = this.effectDate && this.effectDate.length > 0 ? this.effectDate[0] : "";
      para.endTime = this.effectDate && this.effectDate.length > 0 ? this.effectDate[1] : "";
      para.areaList = this.selectedArea.map((item) => {
        return {
          areaCode: item.areaCode,
          areaName: item.areaName,
        };
      });
      this.isSaving = true;
      this.isLoading = false;
      this.$fetch({
        api: this.isEdit ? NESTLE_TRADE_BACK_SERVER_ORDER_BAN_RULE_UPDATE : NESTLE_TRADE_BACK_SERVER_ORDER_BAN_RULE_SAVE,
        para,
      })
        .then((res) => {
          this.isSaving = false;
          this.isLoading = false;
          tip("操作成功");
          this.onCancel(true, true);
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    changeDate(date) {
      this.effectDate = date;
    },
    openAreaPopupShow() {
      this.getProvinceList();
      this.isShowAreaPopup = true;
    },
    openWarehousePopupShow() {
      this.getWareSeatList();
    },
    getProvinceList() {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_BASE_DATA_AREA_LIST,
        para: {},
      })
        .then((res) => {
          //去除非中国地区
          let arrList = res.filter((v) => v.level == "3" || v.level == "4" || v.parentCode == "CHN");
          let province = arrList.filter((v) => v.level == "2");
          let city = arrList.filter((v) => v.level == "3");
          let area = arrList.filter((v) => v.level == "4");
          const arr = province;

          city.map((c) => {
            c.children = [];
            area.map((a) => {
              if (c.areaCode == a.parentCode) {
                c.children.push(a);
              }
            });
          });

          arr.map((p) => {
            p.children = [];
            city.map((c) => {
              if (p.areaCode == c.parentCode) {
                p.children.push(c);
              }
            });
          });

          this.provinceList = [
            {
              areaCode: "0",
              areaName: "全部",
              level: "0",
              parentCode: "0",
              children: arr,
            },
          ];

          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getWareSeatList() {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_WARE_LIST,
        para: {},
      }).then((res) => {
        this.wareSeatList = res || [];
        this.isLoading = false;
        this.isShowWareHousePopup = true;
      });
    },
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {},
      }).then((res) => {
        this.channelList = res || [];
      });
    },
    getSwitchDetail(id) {
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_ORDER_BAN_RULE_DETAIL,
        para: { id },
      })
        .then(async (res) => {
          this.originData = JSON.parse(JSON.stringify(res));
          this.editPara = res;
          this.effectDate = [this.editPara.startTime, this.editPara.endTime];
          let saleChannelList = [];
          let clientTypeList = [];
          let wcodeList = [];
          let areaList = [];
          let selectedWareSeatRows = [];
          let selectedAreaRows = [];
          if (this.editPara.saleChannelList && this.editPara.saleChannelList.length > 0) {
            for (let i = 0; i < this.editPara.saleChannelList.length; i++) {
              saleChannelList.push(this.editPara.saleChannelList[i].saleChannelCode);
            }
          }
          if (this.editPara.clientTypeList && this.editPara.clientTypeList.length > 0) {
            for (let i = 0; i < this.editPara.clientTypeList.length; i++) {
              clientTypeList.push(this.editPara.clientTypeList[i].clientType);
            }
          }
          if (this.editPara.wareSeats && this.editPara.wareSeats.length > 1) {
            for (let i = 0; i < this.editPara.wareSeats.length; i++) {
              wcodeList.push(this.editPara.wareSeats[i].wareSeatCode);
              selectedWareSeatRows.push(this.editPara.wareSeats[i].wareSeatInfo);
            }
          }
          this.isAreaLimit = this.editPara.areaList && this.editPara.areaList.length > 0 ? "1" : "0";
          this.iswareHouseLimit = this.editPara.wcodeList && this.editPara.wcodeList.length > 0 ? "1" : "0";

          this.$fetch({
            api: NESTLE_TRADE_BACK_SERVER_BASE_DATA_AREA_LIST,
            para: {},
          }).then((r) => {
            //去掉非中国地区
            let arrList = r.filter((v) => v.level == "3" || v.level == "4" || v.parentCode == "CHN");
            let province = arrList.filter((v) => v.level == "2");
            let city = arrList.filter((v) => v.level == "3");
            let area = arrList.filter((v) => v.level == "4");
            const arr = province;

            city.map((c) => {
              c.children = [];
              area.map((a) => {
                if (c.areaCode == a.parentCode) {
                  c.children.push(a);
                }
              });
            });

            arr.map((p) => {
              p.children = [];
              city.map((c) => {
                if (p.areaCode == c.parentCode) {
                  p.children.push(c);
                }
              });
            });
            //暂时存储数据
            let selectList = [];
            arrList.slice().map((y) => {
              res.areaList.map((s) => {
                // 判断已选id是否跟数据源相等，或者已选id跟数据源的上级是否相等
                if (s.areaCode == y.areaCode) {
                  selectList.push(y);
                  selectedAreaRows.push(y.areaCode);
                  areaList.push(y);
                }
                if (s.areaCode == y.parentCode) {
                  selectList.push(y);
                  selectedAreaRows.push(y.areaCode);
                  areaList.push(y);
                }
              });
            });
            selectList.map((t) => {
              if (t.level == "3" && !areaList.find((i) => i.parentCode == t.areaCode)) {
                t.children.map((f) => {
                  selectedAreaRows.push(f.areaCode);
                  areaList.push(f);
                });
              }
            });
            // 已选地区
            this.selectedAreaRows = areaList;
            // 已选地区id
            this.$set(this.editPara, "areaList", selectedAreaRows);
          });

          this.$set(this.editPara, "saleChannelList", saleChannelList);
          this.$set(this.editPara, "clientTypeList", clientTypeList);
          this.$set(this.editPara, "wcodeList", wcodeList);
          this.$set(this.originData, "wcodeList", this.editPara.wcodeList);
          this.$set(this.originData, "saleChannelList", this.editPara.saleChannelList);
          this.$set(this.originData, "clientTypeList", this.editPara.clientTypeList);
          this.$set(this, "selectedWareSeatRows", selectedWareSeatRows);
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onSubmit() {
      if (this.whitelist) {
        this.editPara.whitelist = [];
        let temp = this.whitelist.split(",");
        let whitelist = [];
        for (let i = 0; i < temp.length; i++) {
          whitelist.push({ value: temp[i] });
        }
        this.editPara.whitelist = this.editPara.whitelist.concat(whitelist);
        this.whitelist = "";
        this.isShowPopup = false;
      }
    },
    onDelete(index) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该白名单？",
        ok: () => {
          this.editPara.whitelist.splice(index, 1);
          let temp = [];
          for (let i = 0; i < this.editPara.whitelist.length; i++) {
            temp.push(this.editPara.whitelist[i].value);
          }
          this.whitelist = temp.join(",");
        },
      });
    },
  },
  created() {
    this.getChannelList();
    const { id, edit, view } = this.$route.query;
    if (id) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }

      this.getSwitchDetail(id);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id, edit, view } = to.query;
    this.editPara = initEditPara();
    this.isAreaLimit = "";
    this.selectedAreaRows = [];
    this.selectedArea = [];
    this.iswareHouseLimit = "";
    this.selectedWareSeatRows = [];
    this.effectDate = "";
    if (id) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.getSwitchDetail(id);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
    next();
  },
};
</script>

<style lang="postcss" module="css">
.box {
  min-height: 125px;
  padding: 10px;
  border: 1px solid #f0f2f5;
}
.whiteBox {
  position: relative;
  & > .tip {
    position: absolute;
    width: 246px;
    height: 60px;
    left: 85px;
    top: -60px;
    padding: 10px 15px;
    line-height: 20px;
    background-color: #5b5858;
    color: #fff;
    border-radius: 10px;
    display: none;
  }
}
.whiteBox:hover {
  cursor: pointer;
}
.whiteBox:hover .tip {
  display: block;
}
.btn {
  width: 100px;
}
.whiteList {
  display: inline-block;
  margin-left: 20px;
  & > span {
    font-size: 15px;
    margin-right: 3px;
  }
}
</style>
